// Pure helpers for the campaign editor's step list (kept out of index.js so they can be tested).
//
// A step's `order` is its permanent number: the server records who was sent which step by that
// number, so renumbering after a removal made people skip the step that slid into a sent slot.
// Numbers are therefore never changed or reused here (the server enforces the same on save).

export function removeStep(steps, idx) {
  return steps.filter((_, i) => i !== idx);
}

// The next new step's number: above every current step and above `highestSeen`, the highest
// number this editor has shown (so a step removed in this session is not reused).
export function nextStepOrder(steps, highestSeen = 0) {
  return steps.reduce((m, s) => Math.max(m, s.order || 0), highestSeen || 0) + 1;
}

// After an attachment upload/removal the server returns the whole saved campaign. Only that
// step's attachment list is taken from it, so edits not saved yet (on any step) survive.
export function mergeStepAttachments(steps, savedCampaign, stepId) {
  const saved = (savedCampaign?.steps || []).find((s) => String(s._id) === String(stepId));
  if (!saved) return steps;
  return steps.map((s) =>
    String(s._id) === String(stepId)
      ? { ...s, email: { ...s.email, attachments: saved.email?.attachments || [] } }
      : s
  );
}

// Same limit as the server (routes/autoresponder.js) — checked first so a big file fails fast.
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export function attachmentSizeError(file) {
  return file && file.size > MAX_ATTACHMENT_BYTES
    ? `${file.name} is larger than the 10 MB limit, so it was not attached.`
    : "";
}
